m = require 'mithril'

module.exports = (store) -> (next) -> (action) ->
	# Tell Mithril to redraw after each action
	m.startComputation()
	result = next action
	m.endComputation()
	
	result